import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

export default function useABTestForm() {
  return useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: 'onBlur',
  });
}

const defaultValues = {
  projectId: -1,
  growthBookFeatureName: '',
  senderName: '',
  senderEmail: '',
  force_choose: '-1',
  scheduledTime: '',
  csvFiles: [],
};

const schema = yup.object().shape({
  projectId: yup
    .number()
    .min(1, 'ECS Project is required')
    .required()
    .label('ECS Project'),
  growthBookFeatureName: yup
    .string()
    .required()
    .label('GrowthBook Feature'),
  senderName: yup
    .string()
    .label('Sender Name')
    .when('force_choose', {
      is: 'SendGrid',
      then: yup.string(),
      otherwise: yup.string().required(),
    }),
  senderEmail: yup
    .string()
    .label('Sender Email')
    .when('force_choose', {
      is: 'SendGrid',
      then: yup.string(),
      otherwise: yup
        .string()
        .email()
        .required(),
    }),
  csvFiles: yup.array().min(1, 'Please upload a csv file'),
});
